import { makeStyles } from '@material-ui/styles';

import {
  MARGIN_BOTTOM_TOOLBAR,
  MARGIN_TOP_TOOLBAR,
  SIZE,
} from './sideBarDialog.const';
import { neutral } from 'shared/styles/colors';

import type {
  MarginBottomToolbar,
  MarginTopToolbar,
  SizeExtended,
} from './sideBarDialog.type';

export default makeStyles({
  modal: {
    inset: 'unset !important',
  },
  backdrop: (props: Props) => ({
    marginTop: props.marginTopToolbar ?? MARGIN_TOP_TOOLBAR,
    marginBottom: props.marginBottomToolbar ?? MARGIN_BOTTOM_TOOLBAR,
  }),
  drawerPaper: ({
    marginTopToolbar = MARGIN_TOP_TOOLBAR,
    marginBottomToolbar = MARGIN_BOTTOM_TOOLBAR,
    size = '',
  }: Props) => ({
    height: `calc(100% - ${marginTopToolbar} - ${marginBottomToolbar})`,
    width: '100%',
    maxWidth: SIZE[size] ?? (Boolean(size) ? size : SIZE['medium']),
    marginTop: marginTopToolbar,
    marginBottom: marginBottomToolbar,
    padding: '1rem 1rem 1.5rem',
    gap: '1rem',
    justifyContent: 'space-between',
    fontFamily: 'PP Object Sans',
    fontWeight: 'normal',
    boxShadow: 'none',
    color: neutral['100'],
    border: `1px solid ${neutral['20']}`,
    '& *': {
      fontFamily: 'PP Object Sans',
    },
  }),
  headerNav: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&[data-has-posnav="true"]': {
      marginBottom: '1rem',
    },
  },
  headerNavMain: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  headerTitle: {
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1.25rem',
  },

  main: {
    height: '100%',
    overflowY: 'auto',
  },

  footer: {
    display: 'flex',
    gap: '0.5rem',
    flexDirection: 'column',
  },
  primaryBtn: {
    padding: '1rem',
    lineHeight: '1rem',
    fontSize: '0.875rem',
    borderRadius: '0.75rem',
    color: neutral['20'],
    backgroundColor: neutral['100'],
    '&:hover': {
      boxShadow: 'none',
      color: neutral.white,
      backgroundColor: neutral['80'],
    },
  },
  secondaryBtn: {
    padding: '1rem',
    lineHeight: '1rem',
    fontSize: '0.875rem',
    color: neutral['100'],
    borderRadius: '0.75rem',
    '&:hover': {
      color: neutral['80'],
      backgroundColor: neutral['20'],
    },
  },
});

interface Props {
  marginBottomToolbar?: MarginBottomToolbar;
  marginTopToolbar?: MarginTopToolbar;
  size?: SizeExtended;
}
